webpackJsonp([268272430289628],{

/***/ 715:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"contentfulNovica":{"id":"c6oY3WQFLMYWxmKNhQYFzjO","naslov":"Osnovni intenzivni tečaj","createdAt":"2019-10-28T11:13:20.162Z","slika":{"file":{"url":"//images.ctfassets.net/0mpr9vmqs1v8/3j4I3KiDhCgr1eSlu99s9A/579b470d04e82e598c10651141bd04a7/osnovni_te_aj_16.11..jpg"},"description":""},"tekst":{"tekst":"V novembru organiziramo letošnji prvi intenzivni vikend-tečaj badmintona.\nNa tečaju se bomo učili tehniko gibanja po igrišču in tehniko osnovnih udarcev.\n\nTečaj je primeren za začetnike in malo boljše igralce, ki bi želeli osvežiti svoje znanje.\n\nŠtevilo udeležencev je od 4 do 8. V kolikor bo zanimanje večje, bomo naredili dodatno skupino, ki jo bo vodil klubski trener.\nPrijavite se na bklub.bit@gmail.com in ob prijavi tudi poravnate kotizacijo ter si s tem rezervirate mesto na tečaju. Pohitite torej z prijavami.\n\nTečaj bo potekal v dvorani Bit Centra, v soboto, 16.11. in nedeljo, 17.11.2019.\n\nVabljeni!"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---novice-c-6-o-y-3-wqflmy-wxm-k-nh-qy-fzj-o-98120bee01deb49dca3e.js